// extracted by mini-css-extract-plugin
export default {"root":"SwipingComponent__root--Kck6Q"};